import type {BymoPageActionMediaViewSettings} from '../bymo-pages';
import {
    BymoPageActionMediaLayout,
    BymoPageActionMediaSize,
    BymoPageActionMediaSizing,
    BymoPageActionMediaViewLayout
} from '../bymo-pages';
import {HtmlObjectHorizontalPosition, HtmlObjectVerticalPosition} from '@wix/devzai-utils-common';

export interface DoppeActionMediaViewSettings {
    mainMediaViewSettings: BymoPageActionMediaViewSettings;
    mainMediaViewLayout: BymoPageActionMediaViewLayout;
}

export function doppeActionGetMediaViewDefaultSettingsMigration (
    settings: Partial<DoppeActionMediaViewSettings>
) {
    return {
        mainMediaViewSettings: {
            mediaLayout: settings.mainMediaViewSettings?.mediaLayout ?? BymoPageActionMediaLayout.Cropped,
            mediaSizing: settings.mainMediaViewSettings?.mediaSizing ?? BymoPageActionMediaSizing.Custom,
            size: settings.mainMediaViewSettings?.size ?? BymoPageActionMediaSize.Ratio3By2,
            alignment: settings.mainMediaViewSettings?.alignment ?? {
                horizontal: HtmlObjectHorizontalPosition.Center,
                vertical: HtmlObjectVerticalPosition.Center
            },
        },
        mainMediaViewLayout: settings.mainMediaViewLayout ?? BymoPageActionMediaViewLayout.WithMargins,
    } satisfies DoppeActionMediaViewSettings;
}

